import type {
  AiDetectionDetailsData,
  AiDetectorAnalysisData
} from '@/app/ContentTools/types/aiContentAnalysisApiTypes';

const getVerdict = (humanLikeness: number) => {
  if (humanLikeness >= 75) return 'شباهت بیشتر به انسان';
  if (humanLikeness >= 50) return 'شباهت بیشتر به انسان';
  if (humanLikeness >= 25) return 'شباهت بیشتر به AI';
  return 'شباهت بیشتر به AI';
};

const mapAiDetectionData = (
  data: AiDetectionDetailsData | null | undefined
): AiDetectorAnalysisData | null => {
  if (!data) return null;

  const report = data.ai_detection_report;
  const aiLikeness = report?.ai_likeness ?? data.ai_likeness;
  const humanLikeness = report?.human_likeness ?? data.human_likeness;
  const message = data.ai_detection || data.message || '';
  const hasScores =
    typeof aiLikeness === 'number' || typeof humanLikeness === 'number';

  if (!message && !hasScores) return null;

  const resolvedHuman = humanLikeness ?? 0;
  const resolvedAi = aiLikeness ?? 0;

  return {
    id: String(data.id || data.task_id || ''),
    keyword: data.keyword || '',
    ai_likeness: resolvedAi,
    human_likeness: resolvedHuman,
    confidence: report?.confidence || data.confidence || '',
    verdict: getVerdict(resolvedHuman),
    criteria: [],
    ai_signals: report?.ai_signals || data.ai_signals || [],
    human_signals: report?.human_signals || data.human_signals || [],
    message
  };
};

export default mapAiDetectionData;
